/* Full product navigation keeps third-party bundle apps in their native context. */
if (!customElements.get('occhio-lens-catalog')) {
  customElements.define('occhio-lens-catalog', class extends HTMLElement {
    connectedCallback() {
      const current = new URL(window.location.href);
      const links = [...this.querySelectorAll('[data-lens-link]')];
      for (const link of links) {
        const url = new URL(link.href);
        // Preserve an unpublished theme preview while moving between products.
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        link.href = url.href;
      }
      if (this.dataset.entry === 'true' && !this.hasAttribute('data-editor') && !window.Shopify?.designMode) {
        const first = links.find(link => link.dataset.available === 'true') || links[0];
        if (first && new URL(first.href).pathname !== current.pathname) {
          window.location.replace(first.href);
        }
      }
    }
  });
}
